import { type Locale } from 'date-fns/locale/types';

// @see https://github.com/date-fns/date-fns/issues/3660#issuecomment-2209879062
export const dateFnsLocaleMap = {
  af: (): Promise<typeof import('date-fns/locale/af')> => /* webpackMode: "lazy", webpackChunkName: "af':" */ import('date-fns/locale/af'),
  ar: (): Promise<typeof import('date-fns/locale/ar')> => /* webpackMode: "lazy", webpackChunkName: "ar':" */ import('date-fns/locale/ar'),
  'ar-DZ': (): Promise<typeof import('date-fns/locale/ar-DZ')> =>
    /* webpackMode: "lazy", webpackChunkName: "ar-DZ" */ import('date-fns/locale/ar-DZ'),
  'ar-EG': (): Promise<typeof import('date-fns/locale/ar-EG')> =>
    /* webpackMode: "lazy", webpackChunkName: "ar-EG" */ import('date-fns/locale/ar-EG'),
  'ar-MA': (): Promise<typeof import('date-fns/locale/ar-MA')> =>
    /* webpackMode: "lazy", webpackChunkName: "ar-MA" */ import('date-fns/locale/ar-MA'),
  'ar-SA': (): Promise<typeof import('date-fns/locale/ar-SA')> =>
    /* webpackMode: "lazy", webpackChunkName: "ar-SA" */ import('date-fns/locale/ar-SA'),
  'ar-TN': (): Promise<typeof import('date-fns/locale/ar-TN')> =>
    /* webpackMode: "lazy", webpackChunkName: "ar-TN" */ import('date-fns/locale/ar-TN'),
  az: (): Promise<typeof import('date-fns/locale/az')> => /* webpackMode: "lazy", webpackChunkName: "az':" */ import('date-fns/locale/az'),
  be: (): Promise<typeof import('date-fns/locale/be')> => /* webpackMode: "lazy", webpackChunkName: "be':" */ import('date-fns/locale/be'),
  'be-tarask': (): Promise<typeof import('date-fns/locale/be-tarask')> =>
    /* webpackMode: "lazy", webpackChunkName: "be-tarask" */ import('date-fns/locale/be-tarask'),
  bg: (): Promise<typeof import('date-fns/locale/bg')> => /* webpackMode: "lazy", webpackChunkName: "bg':" */ import('date-fns/locale/bg'),
  bn: (): Promise<typeof import('date-fns/locale/bn')> => /* webpackMode: "lazy", webpackChunkName: "bn':" */ import('date-fns/locale/bn'),
  bs: (): Promise<typeof import('date-fns/locale/bs')> => /* webpackMode: "lazy", webpackChunkName: "bs':" */ import('date-fns/locale/bs'),
  ca: (): Promise<typeof import('date-fns/locale/ca')> => /* webpackMode: "lazy", webpackChunkName: "ca':" */ import('date-fns/locale/ca'),
  ckb: (): Promise<typeof import('date-fns/locale/ckb')> =>
    /* webpackMode: "lazy", webpackChunkName: "ckb':" */ import('date-fns/locale/ckb'),
  cs: (): Promise<typeof import('date-fns/locale/cs')> => /* webpackMode: "lazy", webpackChunkName: "cs':" */ import('date-fns/locale/cs'),
  cy: (): Promise<typeof import('date-fns/locale/cy')> => /* webpackMode: "lazy", webpackChunkName: "cy':" */ import('date-fns/locale/cy'),
  da: (): Promise<typeof import('date-fns/locale/da')> => /* webpackMode: "lazy", webpackChunkName: "da':" */ import('date-fns/locale/da'),
  de: (): Promise<typeof import('date-fns/locale/de')> => /* webpackMode: "lazy", webpackChunkName: "de':" */ import('date-fns/locale/de'),
  'de-AT': (): Promise<typeof import('date-fns/locale/de-AT')> /* webpackMode: "lazy", webpackChunkName: "de-AT" */ =>
    import('date-fns/locale/de-AT'),
  el: (): Promise<typeof import('date-fns/locale/el')> => /* webpackMode: "lazy", webpackChunkName: "el':" */ import('date-fns/locale/el'),
  'en-AU': (): Promise<typeof import('date-fns/locale/en-AU')> /* webpackMode: "lazy", webpackChunkName: "en-AU" */ =>
    import('date-fns/locale/en-AU'),
  'en-CA': (): Promise<typeof import('date-fns/locale/en-CA')> /* webpackMode: "lazy", webpackChunkName: "en-CA" */ =>
    import('date-fns/locale/en-CA'),
  'en-GB': (): Promise<typeof import('date-fns/locale/en-GB')> /* webpackMode: "lazy", webpackChunkName: "en-GB" */ =>
    import('date-fns/locale/en-GB'),
  'en-IE': (): Promise<typeof import('date-fns/locale/en-IE')> /* webpackMode: "lazy", webpackChunkName: "en-IE" */ =>
    import('date-fns/locale/en-IE'),
  'en-IN': (): Promise<typeof import('date-fns/locale/en-IN')> /* webpackMode: "lazy", webpackChunkName: "en-IN" */ =>
    import('date-fns/locale/en-IN'),
  'en-NZ': (): Promise<typeof import('date-fns/locale/en-NZ')> /* webpackMode: "lazy", webpackChunkName: "en-NZ" */ =>
    import('date-fns/locale/en-NZ'),
  'en-US': (): Promise<typeof import('date-fns/locale/en-US')> /* webpackMode: "lazy", webpackChunkName: "en-US" */ =>
    import('date-fns/locale/en-US'),
  'en-ZA': (): Promise<typeof import('date-fns/locale/en-ZA')> /* webpackMode: "lazy", webpackChunkName: "en-ZA" */ =>
    import('date-fns/locale/en-ZA'),
  eo: (): Promise<typeof import('date-fns/locale/eo')> => /* webpackMode: "lazy", webpackChunkName: "eo':" */ import('date-fns/locale/eo'),
  es: (): Promise<typeof import('date-fns/locale/es')> => /* webpackMode: "lazy", webpackChunkName: "es':" */ import('date-fns/locale/es'),
  et: (): Promise<typeof import('date-fns/locale/et')> => /* webpackMode: "lazy", webpackChunkName: "et':" */ import('date-fns/locale/et'),
  eu: (): Promise<typeof import('date-fns/locale/eu')> => /* webpackMode: "lazy", webpackChunkName: "eu':" */ import('date-fns/locale/eu'),
  'fa-IR': (): Promise<typeof import('date-fns/locale/fa-IR')> /* webpackMode: "lazy", webpackChunkName: "fa-IR" */ =>
    import('date-fns/locale/fa-IR'),
  fi: (): Promise<typeof import('date-fns/locale/fi')> => /* webpackMode: "lazy", webpackChunkName: "fi':" */ import('date-fns/locale/fi'),
  fr: (): Promise<typeof import('date-fns/locale/fr')> => /* webpackMode: "lazy", webpackChunkName: "fr':" */ import('date-fns/locale/fr'),
  'fr-CA': (): Promise<typeof import('date-fns/locale/fr-CA')> /* webpackMode: "lazy", webpackChunkName: "fr-CA" */ =>
    import('date-fns/locale/fr-CA'),
  'fr-CH': (): Promise<typeof import('date-fns/locale/fr-CH')> /* webpackMode: "lazy", webpackChunkName: "fr-CH" */ =>
    import('date-fns/locale/fr-CH'),
  fy: (): Promise<typeof import('date-fns/locale/fy')> => /* webpackMode: "lazy", webpackChunkName: "fy':" */ import('date-fns/locale/fy'),
  gd: (): Promise<typeof import('date-fns/locale/gd')> => /* webpackMode: "lazy", webpackChunkName: "gd':" */ import('date-fns/locale/gd'),
  gl: (): Promise<typeof import('date-fns/locale/gl')> => /* webpackMode: "lazy", webpackChunkName: "gl':" */ import('date-fns/locale/gl'),
  gu: (): Promise<typeof import('date-fns/locale/gu')> => /* webpackMode: "lazy", webpackChunkName: "gu':" */ import('date-fns/locale/gu'),
  he: (): Promise<typeof import('date-fns/locale/he')> => /* webpackMode: "lazy", webpackChunkName: "he':" */ import('date-fns/locale/he'),
  hi: (): Promise<typeof import('date-fns/locale/hi')> => /* webpackMode: "lazy", webpackChunkName: "hi':" */ import('date-fns/locale/hi'),
  hr: (): Promise<typeof import('date-fns/locale/hr')> => /* webpackMode: "lazy", webpackChunkName: "hr':" */ import('date-fns/locale/hr'),
  ht: (): Promise<typeof import('date-fns/locale/ht')> => /* webpackMode: "lazy", webpackChunkName: "ht':" */ import('date-fns/locale/ht'),
  hu: (): Promise<typeof import('date-fns/locale/hu')> => /* webpackMode: "lazy", webpackChunkName: "hu':" */ import('date-fns/locale/hu'),
  hy: (): Promise<typeof import('date-fns/locale/hy')> => /* webpackMode: "lazy", webpackChunkName: "hy':" */ import('date-fns/locale/hy'),
  id: (): Promise<typeof import('date-fns/locale/id')> => /* webpackMode: "lazy", webpackChunkName: "id':" */ import('date-fns/locale/id'),
  is: (): Promise<typeof import('date-fns/locale/is')> => /* webpackMode: "lazy", webpackChunkName: "is':" */ import('date-fns/locale/is'),
  it: (): Promise<typeof import('date-fns/locale/it')> => /* webpackMode: "lazy", webpackChunkName: "it':" */ import('date-fns/locale/it'),
  'it-CH': (): Promise<typeof import('date-fns/locale/it-CH')> /* webpackMode: "lazy", webpackChunkName: "it-CH" */ =>
    import('date-fns/locale/it-CH'),
  ja: (): Promise<typeof import('date-fns/locale/ja')> => /* webpackMode: "lazy", webpackChunkName: "ja':" */ import('date-fns/locale/ja'),
  'ja-Hira': (): Promise<typeof import('date-fns/locale/ja-Hira')> /* webpackMode: "lazy", webpackChunkName: "ja-Hira" */ =>
    import('date-fns/locale/ja-Hira'),
  ka: (): Promise<typeof import('date-fns/locale/ka')> => /* webpackMode: "lazy", webpackChunkName: "ka':" */ import('date-fns/locale/ka'),
  kk: (): Promise<typeof import('date-fns/locale/kk')> => /* webpackMode: "lazy", webpackChunkName: "kk':" */ import('date-fns/locale/kk'),
  km: (): Promise<typeof import('date-fns/locale/km')> => /* webpackMode: "lazy", webpackChunkName: "km':" */ import('date-fns/locale/km'),
  kn: (): Promise<typeof import('date-fns/locale/kn')> => /* webpackMode: "lazy", webpackChunkName: "kn':" */ import('date-fns/locale/kn'),
  ko: (): Promise<typeof import('date-fns/locale/ko')> => /* webpackMode: "lazy", webpackChunkName: "ko':" */ import('date-fns/locale/ko'),
  lb: (): Promise<typeof import('date-fns/locale/lb')> => /* webpackMode: "lazy", webpackChunkName: "lb':" */ import('date-fns/locale/lb'),
  lt: (): Promise<typeof import('date-fns/locale/lt')> => /* webpackMode: "lazy", webpackChunkName: "lt':" */ import('date-fns/locale/lt'),
  lv: (): Promise<typeof import('date-fns/locale/lv')> => /* webpackMode: "lazy", webpackChunkName: "lv':" */ import('date-fns/locale/lv'),
  mk: (): Promise<typeof import('date-fns/locale/mk')> => /* webpackMode: "lazy", webpackChunkName: "mk':" */ import('date-fns/locale/mk'),
  mn: (): Promise<typeof import('date-fns/locale/mn')> => /* webpackMode: "lazy", webpackChunkName: "mn':" */ import('date-fns/locale/mn'),
  ms: (): Promise<typeof import('date-fns/locale/ms')> => /* webpackMode: "lazy", webpackChunkName: "ms':" */ import('date-fns/locale/ms'),
  mt: (): Promise<typeof import('date-fns/locale/mt')> => /* webpackMode: "lazy", webpackChunkName: "mt':" */ import('date-fns/locale/mt'),
  nb: (): Promise<typeof import('date-fns/locale/nb')> => /* webpackMode: "lazy", webpackChunkName: "nb':" */ import('date-fns/locale/nb'),
  nl: (): Promise<typeof import('date-fns/locale/nl')> => /* webpackMode: "lazy", webpackChunkName: "nl':" */ import('date-fns/locale/nl'),
  'nl-BE': (): Promise<typeof import('date-fns/locale/nl-BE')> /* webpackMode: "lazy", webpackChunkName: "nl-BE" */ =>
    import('date-fns/locale/nl-BE'),
  nn: (): Promise<typeof import('date-fns/locale/nn')> => /* webpackMode: "lazy", webpackChunkName: "nn':" */ import('date-fns/locale/nn'),
  oc: (): Promise<typeof import('date-fns/locale/oc')> => /* webpackMode: "lazy", webpackChunkName: "oc':" */ import('date-fns/locale/oc'),
  pl: (): Promise<typeof import('date-fns/locale/pl')> => /* webpackMode: "lazy", webpackChunkName: "pl':" */ import('date-fns/locale/pl'),
  pt: (): Promise<typeof import('date-fns/locale/pt')> => /* webpackMode: "lazy", webpackChunkName: "pt':" */ import('date-fns/locale/pt'),
  'pt-BR': (): Promise<typeof import('date-fns/locale/pt-BR')> /* webpackMode: "lazy", webpackChunkName: "pt-BR" */ =>
    import('date-fns/locale/pt-BR'),
  ro: (): Promise<typeof import('date-fns/locale/ro')> => /* webpackMode: "lazy", webpackChunkName: "ro':" */ import('date-fns/locale/ro'),
  ru: (): Promise<typeof import('date-fns/locale/ru')> => /* webpackMode: "lazy", webpackChunkName: "ru':" */ import('date-fns/locale/ru'),
  se: (): Promise<typeof import('date-fns/locale/se')> => /* webpackMode: "lazy", webpackChunkName: "se':" */ import('date-fns/locale/se'),
  sk: (): Promise<typeof import('date-fns/locale/sk')> => /* webpackMode: "lazy", webpackChunkName: "sk':" */ import('date-fns/locale/sk'),
  sl: (): Promise<typeof import('date-fns/locale/sl')> => /* webpackMode: "lazy", webpackChunkName: "sl':" */ import('date-fns/locale/sl'),
  sq: (): Promise<typeof import('date-fns/locale/sq')> => /* webpackMode: "lazy", webpackChunkName: "sq':" */ import('date-fns/locale/sq'),
  sr: (): Promise<typeof import('date-fns/locale/sr')> => /* webpackMode: "lazy", webpackChunkName: "sr':" */ import('date-fns/locale/sr'),
  'sr-Latn': (): Promise<typeof import('date-fns/locale/sr-Latn')> /* webpackMode: "lazy", webpackChunkName: "sr-Latn" */ =>
    import('date-fns/locale/sr-Latn'),
  sv: (): Promise<typeof import('date-fns/locale/sv')> => /* webpackMode: "lazy", webpackChunkName: "sv':" */ import('date-fns/locale/sv'),
  ta: (): Promise<typeof import('date-fns/locale/ta')> => /* webpackMode: "lazy", webpackChunkName: "ta':" */ import('date-fns/locale/ta'),
  te: (): Promise<typeof import('date-fns/locale/te')> => /* webpackMode: "lazy", webpackChunkName: "te':" */ import('date-fns/locale/te'),
  th: (): Promise<typeof import('date-fns/locale/th')> => /* webpackMode: "lazy", webpackChunkName: "th':" */ import('date-fns/locale/th'),
  tr: (): Promise<typeof import('date-fns/locale/tr')> => /* webpackMode: "lazy", webpackChunkName: "tr':" */ import('date-fns/locale/tr'),
  ug: (): Promise<typeof import('date-fns/locale/ug')> => /* webpackMode: "lazy", webpackChunkName: "ug':" */ import('date-fns/locale/ug'),
  uk: (): Promise<typeof import('date-fns/locale/uk')> => /* webpackMode: "lazy", webpackChunkName: "uk':" */ import('date-fns/locale/uk'),
  uz: (): Promise<typeof import('date-fns/locale/uz')> => /* webpackMode: "lazy", webpackChunkName: "uz':" */ import('date-fns/locale/uz'),
  'uz-Cyrl': (): Promise<typeof import('date-fns/locale/uz-Cyrl')> /* webpackMode: "lazy", webpackChunkName: "uz-Cyrl" */ =>
    import('date-fns/locale/uz-Cyrl'),
  vi: (): Promise<typeof import('date-fns/locale/vi')> => /* webpackMode: "lazy", webpackChunkName: "vi':" */ import('date-fns/locale/vi'),
  'zh-CN': (): Promise<typeof import('date-fns/locale/zh-CN')> /* webpackMode: "lazy", webpackChunkName: "zh-CN" */ =>
    import('date-fns/locale/zh-CN'),
  'zh-HK': (): Promise<typeof import('date-fns/locale/zh-HK')> /* webpackMode: "lazy", webpackChunkName: "zh-HK" */ =>
    import('date-fns/locale/zh-HK'),
  'zh-TW': (): Promise<typeof import('date-fns/locale/zh-TW')> /* webpackMode: "lazy", webpackChunkName: "zh-TW" */ =>
    import('date-fns/locale/zh-TW'),
};

const dateFnsLocaleName = [
  'af',
  'ar',
  'ar-DZ',
  'ar-EG',
  'ar-MA',
  'ar-SA',
  'ar-TN',
  'az',
  'be',
  'be-tarask',
  'bg',
  'bn',
  'bs',
  'ca',
  'ckb',
  'cs',
  'cy',
  'da',
  'de',
  'de-AT',
  'el',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IE',
  'en-IN',
  'en-NZ',
  'en-US',
  'en-ZA',
  'eo',
  'es',
  'et',
  'eu',
  'fa-IR',
  'fi',
  'fr',
  'fr-CA',
  'fr-CH',
  'fy',
  'gd',
  'gl',
  'gu',
  'he',
  'hi',
  'hr',
  'ht',
  'hu',
  'hy',
  'id',
  'is',
  'it',
  'it-CH',
  'ja',
  'ja-Hira',
  'ka',
  'kk',
  'km',
  'kn',
  'ko',
  'lb',
  'lt',
  'lv',
  'mk',
  'mn',
  'ms',
  'mt',
  'nb',
  'nl',
  'nl-BE',
  'nn',
  'oc',
  'pl',
  'pt',
  'pt-BR',
  'ro',
  'ru',
  'se',
  'sk',
  'sl',
  'sq',
  'sr',
  'sr-Latn',
  'sv',
  'ta',
  'te',
  'th',
  'tr',
  'ug',
  'uk',
  'uz',
  'uz-Cyrl',
  'vi',
  'zh-CN',
  'zh-HK',
  'zh-TW',
] as const;

export const getLocale = async (localeString: string): Promise<Locale | undefined> => {
  if (!(dateFnsLocaleName as readonly string[]).includes(localeString)) {
    return undefined;
  }

  type ElementType<T> = T extends Array<infer U> ? U : T extends ReadonlyArray<infer U> ? U : never;
  const typedLocalString = localeString as ElementType<typeof dateFnsLocaleName>;

  return dateFnsLocaleMap[typedLocalString]()
    .then(m => ((m as unknown as { default?: Locale }).default ?? (m as unknown as Locale)) as Locale)
    .catch(() => undefined);
};
